import { useCallback } from "react";
import { useMutation } from "urql";

import { DEFAULT_SNACKBAR_ERROR_MESSAGE } from "../constants/strings";
import { UpdateFiles } from "../features/drive/queries.graphql";
import useShowSnackbar from "./useShowSnackbar";
import { useUrqlResponseHandler } from "./useUrqlResponseHandler";

export const useUpdateFiles = () => {
  const { showError } = useShowSnackbar();
  const { getResponseFromState } = useUrqlResponseHandler();
  const [result, executeMutation] = useMutation(UpdateFiles);

  const updateFiles = useCallback(
    async (
      fileIds: string[],
      updates: Record<string, any>,
      successMessage = "",
      errorMessage = DEFAULT_SNACKBAR_ERROR_MESSAGE,
    ) => {
      try {
        const result = await executeMutation({
          updateFilesInput: {
            fileIds,
            ...updates,
          },
        });

        getResponseFromState({
          state: result,
          successMessage:
            successMessage ||
            `${fileIds.length > 1 ? "All files" : "File"} successfully updated.`,
          errorMessage,
        });
      } catch (e) {
        console.error("Error updating files:", e);
        showError(errorMessage);
      }
    },
    [executeMutation, showError, getResponseFromState],
  );

  return { updateFiles, result };
};
